import axios from "axios";
import axiosInstance from "../../../../../../Utils/axios";

import { paginationQueryParams } from "../../../../../../Utils/paginationParam";
let cancelToken;

const deliveryNoteURL = `api/v1/sales-app/delivery-notes`;
//obtaining the paginated data
export const getDeliveryNote = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${deliveryNoteURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllDeliveryNote = () => axiosInstance.get(`${deliveryNoteURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageDeliveryNote = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${deliveryNoteURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

export const getDeliveryNoteAdditionalChargeList = (id) =>
  axiosInstance.get(`api/v1/core-app/additional-charge/list?is_active=true`);
//get by id
export const getSaleOrderDetailsById = (id) =>
  axiosInstance.get(`api/v1/sales-app/sales-order/retrieve-for-delivery-notes/${id}`);
//get by id
export const getDeliveryNoteById = (id) => axiosInstance.get(`${deliveryNoteURL}/retrieve/${id}`);

//creating function
export const createDeliveryNote = (body) => axiosInstance.post(`${deliveryNoteURL}/create`, body);
//updating function
export const updateDeliveryNote = (id, body) => axiosInstance.patch(`${deliveryNoteURL}/${id}`, body);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${deliveryNoteURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataDeliveryNoteName = (e, cancelToken) =>
  axiosInstance.get(`${deliveryNoteURL}?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
